import { Component, Input } from '@angular/core';

@Component({
    selector: 'fc-product-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less'],
    standalone: false
})
export class ProductHeaderComponent {
    @Input() article;
}
